import React from "react"
import { Navigate } from "react-router-dom"

import UserProfile from "../pages/Authentication/user-profile"
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import Dashboard from "../pages/Dashboard/index"
import DragDashboard from "pages/Dashboard/DragDashboard"

import Roles from "pages/RolesRespons"
import EditRoles from "pages/RolesRespons/EditRoles"
import AddRoles from "pages/RolesRespons/AddRoles"
import AddRolesDynamic from "pages/RolesRespons/AddRolesDynamic"

import Staff from "pages/Staff/index"
import AddStaff from "pages/Staff/AddStaff"
import EditStaff from "pages/Staff/EditStaff/EditStaff"

import CompanySettingIndex from "pages/Setting/CompanySettings"
import GeneralSettingIndex from "pages/Setting/GeneralSettings"
import KnowledgeIndex from "pages/Setting/Knowledge Base"

import AccessDenied from "./AccessDenied"
import configure from "configure"

import CurrentOpening from "pages/Planet/CurrentOpening/CurrentOpening"
import AddCurrentOpening from "pages/Planet/CurrentOpening/AddCurrentOpening"
import EditCurrentOpening from "pages/Planet/CurrentOpening/EditCurrentOpening"

import Testimonial from "pages/Planet/Testimonial/Testimonial"
import AddTestimonial from "pages/Planet/Testimonial/AddTestimonial"
import EditTestimonial from "pages/Planet/Testimonial/EditTestimonial"

import CalenderIndex2 from "pages/Calender/CalenderIndex2"
import CalenderIndex3 from "pages/Calender/CalenderIndex3"

import Crendential from "pages/Credentials/Crendential"
import EditCredential from "pages/Setting/GeneralSettings/EditCredentials/EditIndex"
import Profile from "pages/Profile/Profile"
import GuidelinesPolicy from "pages/GuidelinesPolicy/GuidelinesPolicy"
import ViewDocument from "pages/Profile/ViewDocument"
import RolesPermission from "pages/AuditLog/RolesPermission"
import EditDocument from "pages/Profile/EditDocument"

import KnowledgeBase from "pages/KnowledgeBase/KnowledgeBase"
import Freelancer from "pages/HumanResources/Freelancer/Freelancer"
import EditFreelancer from "pages/HumanResources/Freelancer/EditFreelancer/EditFreelancer"
import AddFreelancer from "pages/HumanResources/Freelancer/AddFreelancer"

import ViewApproveDoc from "pages/Dashboard/ViewApproveDoc"

import Statement from "pages/Reports/Finance/Statement"

import PayrollManagement from "pages/HumanResources/Payroll Management/PayrollManagement"
import PunchDetails from "pages/HumanResources/Payroll Management/Punch Details/PunchDetails"
import ListOfHoliday from "pages/HumanResources/Holidays/ListOfHoliday"
import FestivalIndex from "pages/HumanResources/Festival/FestivalIndex"
import ZithasSOP from "pages/HumanResources/ZithasSOP/index"

import PunchScreen from "pages/HumanResources/Payroll Management/Punch Details/PunchScreen"
import LeaveManagement from "pages/HumanResources/Payroll Management/LeaveManagement/LeaveManagement"
import DevLeaveManagement from "pages/HumanResources/Payroll Management/LeaveManagement/DevLeaveManagement"
import SalarySheet from "pages/HumanResources/Payroll Management/SalarySheet/SalarySheet"
import BankDetails from "pages/HumanResources/Payroll Management/BankDetails/BankDetails"
import SalarySlip from "pages/HumanResources/Payroll Management/SalarySlip/SalarySlip"
import GeneratedSalarySlip from "pages/HumanResources/Payroll Management/SalarySlip/GeneratedSalarySlip"
import PunchPreview from "pages/HumanResources/Payroll Management/Punch Details/PunchPreview"

import StatementFormate from "pages/Reports/Finance/StatementFormate"

import SwipeAndIssuesIndex from "pages/HumanResources/Swipe_and_Issues/SwipeAndIssuesIndex"
import SalaryIndex from "pages/HumanResources/Payroll Management/SalaryProcess/SalaryIndex"
import SalaryLeave from "pages/HumanResources/Payroll Management/SalaryLeave/SalaryLeave"

import HrReport from "pages/HumanResources/Report/HrReport"
import TimeSheetReport from "pages/HumanResources/Report/TimeSheetReport"
import AdvancedTimesheetReport from "pages/HumanResources/Report/AdvancedTimesheetReport"

import Portfolio from "pages/Portfolios/Portfolio/Portfolio"
import Addportfolio from "pages/Portfolios/Portfolio/AddPortfolio"
import ViewPortfolio from "pages/Portfolios/Portfolio/ViewPortfolio"
import CaseStudy from "pages/Portfolios/CaseStudy/CaseStudy"
import EditCasestudy from "pages/Portfolios/CaseStudy/EditCaseStudy"
import ViewCaseStudy from "pages/Portfolios/CaseStudy/ViewCaseStudy"
import EditPortfolio from "pages/Portfolios/Portfolio/EditPortfolio"
import AddCaseStudy from "pages/Portfolios/CaseStudy/AddCaseStudy"

import FreelancerIndex from "pages/Setting/Freelancer"
import AddFreelancerTemplate from "pages/Setting/Freelancer/AddTemplate"
import EditFreelancerTemplate from "pages/Setting/Freelancer/EditTemplate"

import GenerateLinkLetters from "pages/Staff/GenerateLinkLetters"
import LetterAddTemplate from "pages/Setting/CompanySettings/StaffLetters/letterAddTemplate"
import LettersEditTemplate from "pages/Setting/CompanySettings/StaffLetters/LettersEditTemplate"

import SeoReportIndex from "pages/Reports/SeoReport"
import PositionMaster from "pages/Setting/PositionMaster/PositionMaster"
import SalaryMaster from "pages/Setting/SalaryMaster/SalaryMaster"
import EmployeeTypeMaster from "pages/Setting/EmployeeType/EmployeeType"
import EarningDeduction from "pages/Setting/SalaryMaster/EarningDeduction"
import Hirechynew from "pages/Separate/Hirechy/HirechyNew"
import AssessmentTestIndex from "pages/HumanResources/Recruitment/AssessmentExam/index"
import AssessmentResponsesIndex from "pages/HumanResources/Recruitment/AssessmentExam/AssessmentResponsesIndex"
import AssessmentSettingIndex from "pages/Setting/Assessment/index"
import AssessmentFinalForm from "pages/HumanResources/Recruitment/AssessmentExam/SampleForm/index"
import TraineeManagement from "pages/HumanResources/Recruitment/AssessmentExam/TraineeManagement"
import ExEmployeeFeedback from "pages/HumanResources/ExEmployeeFeedback/ExEmployeeFeedback"

const authProtectedRoutes = [
  {
    path: `${configure.appUrl}`,
    exact: true,
    component: <Navigate to={`${configure.appUrl}dashboard`} />,
  },

  {
    path: `${configure.appUrl}dashboard`,
    // component: <Dashboard />,
    component: <DragDashboard />,
  },
  {
    path: `${configure.appUrl}dashboard/drag_drop`,
    component: <Dashboard />,
  },

  {
    path: `${configure.appUrl}profile`,
    component: <Profile />,
  },
  {
    path: `${configure.appUrl}guidelines-policy`,
    component: <GuidelinesPolicy />,
  },


  {
    path: `${configure.appUrl}roles`,
    component: <Roles />,
    module_id: "69",
    type: "view",
  },
  {
    path: `${configure.appUrl}editroles/:id`,
    component: <EditRoles />,
    module_id: "69",
    type: "edit",
  },
  {
    path: `${configure.appUrl}addroles`,
    component: <AddRoles />,
    module_id: "69",
    type: "add",
  },
  {
    path: `${configure.appUrl}addroles/:slug`,
    component: <AddRolesDynamic />,
    module_id: "69",
    type: "add",
  },

  {
    path: `${configure.appUrl}staff`,
    component: <Staff />,
    module_id: "66",
    type: "view",
  },
  {
    path: `${configure.appUrl}addstaff`,
    component: <AddStaff />,
    module_id: "66",
    type: "add",
  },
  {
    path: `${configure.appUrl}edit-staff/:id`,
    component: <EditStaff />,
    module_id: "66",
    type: "edit",
  },

  {
    path: `${configure.appUrl}calendar`,
    component: <CalenderIndex2 />,
    module_id: "85",
    type: "view",
  },

  // Settings
  {
    path: `${configure.appUrl}setting/companysetting`,
    component: <CompanySettingIndex />,
    module_id: "70",
    type: "view",
  },
  {
    path: `${configure.appUrl}setting/generalsetting`,
    component: <GeneralSettingIndex />,
    module_id: "73",
    type: "view",
  },
  {
    path: `${configure.appUrl}setting/generalsetting/:id`,
    component: <EditCredential />,
    module_id: "73",
    type: "edit",
  },
  {
    path: `${configure.appUrl}setting/knowledge-base`,
    component: <KnowledgeIndex />,
    module_id: "81",
    type: "view",
  },

  // Planet
  {
    path: `${configure.appUrl}currentopening`,
    component: <CurrentOpening />,
    module_id: "57",
    type: "view",
  },
  {
    path: `${configure.appUrl}addcurrentopening`,
    component: <AddCurrentOpening />,
    module_id: "57",
    type: "add",
  },
  {
    path: `${configure.appUrl}editcurrentopening`,
    component: <EditCurrentOpening />,
    module_id: "57",
    type: "edit",
  },
  {
    path: `${configure.appUrl}testimonial`,
    component: <Testimonial />,
    module_id: "58",
    type: "view",
  },
  {
    path: `${configure.appUrl}addtestimonial`,
    component: <AddTestimonial />,
    module_id: "58",
    type: "add",
  },
  {
    path: `${configure.appUrl}edittestimonial`,
    component: <EditTestimonial />,
    module_id: "58",
    type: "edit",
  },

  {
    path: `${configure.appUrl}credentials`,
    component: <Crendential />,
    module_id: "10",
    type: "view",
  },

  // Audit
  {
    path: `${configure.appUrl}audit/roles`,
    component: <RolesPermission />,
    module_id: "48",
    type: "view",
  },

  // Freelancer
  {
    path: `${configure.appUrl}freelancer`,
    component: <Freelancer />,
    module_id: "89",
    type: "view",
  },
  {
    path: `${configure.appUrl}freelancer/add-freelancer`,
    component: <AddFreelancer />,
    module_id: "89",
    type: "view",
  },
  {
    path: `${configure.appUrl}editfreelancer/:id`,
    component: <EditFreelancer />,
    module_id: "89",
    type: "view",
  },

  // Payroll
  {
    path: `${configure.appUrl}payroll_management`,
    component: <PayrollManagement />,
  },
  {
    path: `${configure.appUrl}punch-details`,
    component: <PunchDetails />,
  },
  {
    path: `${configure.appUrl}punch-preview`,
    component: <PunchPreview />,
  },
  {
    path: `${configure.appUrl}payroll_management/punch_screen`,
    component: <PunchScreen />,
  },
  {
    path: `${configure.appUrl}payroll_management/salary-sheet`,
    component: <SalarySheet />,
  },
  {
    path: `${configure.appUrl}payroll_management/bank-sheet`,
    component: <BankDetails />,
  },
  {
    path: `${configure.appUrl}payroll_management/swipe_issues`,
    component: <SwipeAndIssuesIndex />,
  },

  {
    path: `${configure.appUrl}payroll-management/salary-process`,
    component: <SalaryIndex />,
  },
  {
    path: `${configure.appUrl}payroll-management/emp-leave-summary`,
    component: <SalaryLeave />,
  },
  {
    path: `${configure.appUrl}payroll-management/salary-slip`,
    component: <SalarySlip />,
  },
  {
    path: `${configure.appUrl}generate-salary-slip/:id`,
    component: <GeneratedSalarySlip />,
  },
  {
    path: `${configure.appUrl}payroll-management/devLeave-management`,
    component: <LeaveManagement />,
  },
  {
    path: `${configure.appUrl}payroll-management/leave-management`,
    component: <DevLeaveManagement />,
  },

  // Docs
  {
    path: `${configure.appUrl}viewdocument/:id`,
    component: <ViewDocument />,
  },
  {
    path: `${configure.appUrl}viewapprovedoc/:id`,
    component: <ViewApproveDoc />,
  },
  {
    path: `${configure.appUrl}editdocument/:id`,
    component: <EditDocument />,
  },

  // Holidays
  {
    path: `${configure.appUrl}holiday_list`,
    component: <ListOfHoliday />,
  },
  {
    path: `${configure.appUrl}festival`,
    component: <FestivalIndex />,
  },
  {
    path: `${configure.appUrl}zithas-sop`,
    component: <ZithasSOP />,
  },

  // Reports
  {
    path: `${configure.appUrl}finance/statement`,
    component: <Statement />,
  },
  {
    path: `${configure.appUrl}reports/finance/statement-formate`,
    component: <StatementFormate />,
  },
  {
    path: `${configure.appUrl}hr-report`,
    component: <HrReport />,
  },
  {
    path: `${configure.appUrl}timesheet-report`,
    component: <TimeSheetReport />,
  },
  {
    path: `${configure.appUrl}advanced-timesheet-report`,
    component: <AdvancedTimesheetReport />,
  },

  // Portfolio
  {
    path: `${configure.appUrl}case-study`,
    component: <CaseStudy />,
  },
  {
    path: `${configure.appUrl}add-case-study`,
    component: <AddCaseStudy />,
  },
  {
    path: `${configure.appUrl}edit-case-study/:id`,
    component: <EditCasestudy />,
  },
  {
    path: `${configure.appUrl}view-case-study/:id`,
    component: <ViewCaseStudy />,
  },
  {
    path: `${configure.appUrl}portfolio`,
    component: <Portfolio />,
  },
  {
    path: `${configure.appUrl}add-portfolio`,
    component: <Addportfolio />,
  },
  {
    path: `${configure.appUrl}edit-portfolio/:id`,
    component: <EditPortfolio />,
  },
  {
    path: `${configure.appUrl}view-portfolio/:id`,
    component: <ViewPortfolio />,
  },

  // Knowledge Base Module
  {
    path: `${configure.appUrl}knowledgebase`,
    component: <KnowledgeBase />,
    module_id: "86",
    type: "view",
  },

  {
    path: `${configure.appUrl}freelancer`,
    component: <Freelancer />,
    module_id: "89",
    type: "view",
  },
  {
    path: `${configure.appUrl}freelancer/add-freelancer`,
    component: <AddFreelancer />,
    module_id: "89",
    type: "view",
  },
  {
    path: `${configure.appUrl}editfreelancer/:id`,
    component: <EditFreelancer />,
    module_id: "89",
    type: "view",
  },



  {
    path: `${configure.appUrl}setting/freelancer`,
    component: <FreelancerIndex />,
    module_id: "67",
    type: "view",
  },
  {
    path: `${configure.appUrl}setting/freelancer/add-template`,
    component: <AddFreelancerTemplate />,
    module_id: "67",
    type: "add",
  },
  {
    path: `${configure.appUrl}setting/freelancer/edit-template/:id`,
    component: <EditFreelancerTemplate />,
    module_id: "67",
    type: "edit",
  },

  // Letters
  {
    path: `${configure.appUrl}setting/add-letter-template`,
    component: <LetterAddTemplate />,
    type: "add",
  },
  {
    path: `${configure.appUrl}setting/edit-letters-template/:id`,
    component: <LettersEditTemplate />,
    type: "edit",
  },

  {
    path: `${configure.appUrl}setting/employee-types`,
    component: <EmployeeTypeMaster />,
    type: "view",
    module_id: "119"
  },

  {
    path: `${configure.appUrl}setting/position-master`,
    component: <PositionMaster />,
    type: "view",
    // module_id: "119"
  },
  {
    path: `${configure.appUrl}setting/salary-master`,
    component: <SalaryMaster />,
    type: "view",
    // module_id: "119"
  },
  {
    path: `${configure.appUrl}setting/earning-deduction`,
    component: <EarningDeduction />,
    type: "view",
    // module_id: "119"
  },

  // Assessment
  {
    path: `${configure.appUrl}assessment-tests`,
    component: <AssessmentTestIndex />,
  },
  {
    path: `${configure.appUrl}assessment-tests/responses/:testId`,
    component: <AssessmentResponsesIndex />,
  },
  {
    path: `${configure.appUrl}setting/assessment`,
    component: <AssessmentSettingIndex />,
  },
  {
    path: `${configure.appUrl}trainee-management`,
    component: <TraineeManagement />,
  },

  // SEO
  {
    path: `${configure.appUrl}seo-report`,
    component: <SeoReportIndex />,
  },

  {
    path: `${configure.appUrl}company-structure`,
    component: <Hirechynew />,
    module_id: "116",
    type: "view",
  },

  {
    path: `${configure.appUrl}ex-employee-feedback`,
    component: <ExEmployeeFeedback />,
  },
]

const publicRoutes = [
  { path: `${configure.appUrl}logout`, component: <Logout /> },
  { path: `${configure.appUrl}assessment-exam/:id`, component: <AssessmentFinalForm /> },
  { path: `${configure.appUrl}login`, component: <Login /> },
  { path: `${configure.appUrl}forgot-password`, component: <ForgetPwd /> },
  { path: `${configure.appUrl}register`, component: <Register /> },
  { path: `${configure.appUrl}access-denied`, component: <AccessDenied /> },
  {
    path: `${configure.appUrl}staff/Letters/:id`,
    component: <GenerateLinkLetters />,
  },
  {
    path: `${configure.appUrl}calendar/:id`,
    component: <CalenderIndex3 />,
  },
]

export { authProtectedRoutes, publicRoutes }
